export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";